import {
  Box,
  SystemIcon,
  Typography,
  CheckboxListItem,
} from '@wishket/design-system';
import { ChangeEvent } from 'react';
import { twMerge } from 'tailwind-merge';

interface CheckBoxItemProps {
  name: string;
  label: string;
  checked: boolean;
  isError?: boolean;
  isOptional?: boolean;
  onClickMore: (name: string) => void;
  onChange: (e: ChangeEvent<HTMLInputElement>, name: string) => void;
}

export const CheckBoxItem = ({
  name,
  label,
  checked,
  isError,
  isOptional,
  onChange,
  onClickMore,
}: CheckBoxItemProps) => {
  return (
    <Box className="flex items-center justify-between">
      <CheckboxListItem
        type="sub"
        checked={checked}
        isError={isError}
        CheckboxClassName={twMerge(
          'cursor-pointer',
          !checked && !isError && 'group-hover:text-w-gray-200'
        )}
        onChange={(e) => onChange(e, name)}
      >
        <Typography variant="body1" className="text-w-gray-900">
          {label}{' '}
          <span className="text-w-gray-400">
            {isOptional ? '(선택)' : '(필수)'}
          </span>
        </Typography>
      </CheckboxListItem>
      <Box
        data-testid={`newsletter-${name}-more-button`}
        onClick={() => {
          onClickMore(name);
        }}
      >
        <SystemIcon
          name="medium_arrow_right"
          className="cursor-pointer text-w-gray-400"
        />
      </Box>
    </Box>
  );
};
